import { jobService } from 'api/jobService';
import { GET_JOB_DETAIL_FAILURE, GET_JOB_DETAIL_REQUEST, GET_JOB_DETAIL_SUCCESS, CLEAR_JOB_DETAIL } from 'constants/actionTypes';
import { jobDetailsPayloadType } from 'type/JobsType';

export const jobDetail = {
  fetchJobDetails,
  clearJobDetails
};

function fetchJobDetails(payload: jobDetailsPayloadType) {
  return async (dispatch: any) => {
    dispatch(request(GET_JOB_DETAIL_REQUEST));
    jobService
      .fetchJobDetails(payload)
      .then((resp:any) => {
        return resp.json();
      })
      .then((data:any) => {
        if (data?.error || data?.message) {
          dispatch(failure(GET_JOB_DETAIL_FAILURE, data?.message || "Error fetching job details"));
        } else {
          dispatch(success(GET_JOB_DETAIL_SUCCESS, data));
        }
      })
      .catch((error:any) => {
        dispatch(failure(GET_JOB_DETAIL_FAILURE, error));
      });
  };
}

function clearJobDetails() {
  return (dispatch: any) => {
    dispatch({ type: CLEAR_JOB_DETAIL });
  };
}

function request(type: string) {
  return { type: type };
}

function success(type: string, data: any) {
  return { type, payload: { data: data } };
}

function failure(type: string, message: string) {
  return { type, payload: { message } };
}
